import Accordion from '../../FLEX/components/component_accordion/accordion';

jQuery(function ($) {


    function getMetaDataOnVariationChange() {
        $('form.variations_form').on('found_variation', function (event, variation) {
            var variationID = variation.variation_id;
            $.ajax({
                url: afp_vars.afp_ajax_url,
                type: 'GET',
                dataType: 'json',
                data: {
                    action: 'get_variation_dealers',
                    variation_id: variationID
                },
                success: function (response) {
                    if (response.success && response.data['dealers'].length > 0) {
                        var dealers_html = '<h2>Where to buy</h2><ul class="variation-dealers-list">';
                        $.each(response.data['dealers'], function (index, dealer) {
                            dealers_html += '<li>';
                            dealers_html += '<a href="' + dealer.url + '" target="_blank">' + dealer.label + '</a>';
                            dealers_html += '</li>';
                        });
                        dealers_html += '</ul>';
                        $('#variation-dealers-container').html(dealers_html);
                    } else {
                        // Clear the container if no dealers are returned.
                        $('#variation-dealers-container').empty();
                    }
                    if (response.success && response.data['desc'].length > 0) {
                        var desc_html = '';
                        $.each(response.data['desc'], function (index, entry) {
                            desc_html += '<section class="component-column accordionItem component-background-center-center flex-12-12 component-column-verticalAlignment-top">';
                            desc_html += '<section data-logo-color="logo-color-dark" class="component-row padding-top-4x padding-bottom-4x accordionHeader component-background-center-center">';
                            desc_html += '<div class="flex-grid component-row-wide component-row-verticalAlignment-center">';
                            desc_html += '<section data-section-id="' + index + '" class="component-column component-background-center-center flex-10-12 component-column-verticalAlignment-center">';
                            desc_html += '<div class="component-paragraph-wrapper component-paragraph component text-align-left">';
                            desc_html += '<p>' + entry.title + '</p>';
                            desc_html += '</div>';
                            desc_html += '</section>';
                            desc_html += '</div>';
                            desc_html += '</section>';
                            desc_html += '<section class="component-column accordionContent component-background-center-center flex-12-12 component-column-verticalAlignment-top">';
                            desc_html += '<div class="component-paragraph-wrapper padding-top-2x component-paragraph component text-align-left">';
                            desc_html += '<p>' + entry.description + '</p>';
                            desc_html += '</div>';
                            desc_html += '</section>';
                            desc_html += '</section>';


                        });
                        $('#variation-desc-container').html(desc_html);
                        const $accordionContainer = $('.accordionContainer');
                        const myAccordion = new Accordion($accordionContainer);
                    } else {
                        // Clear the container if no dealers are returned.
                        $('#variation-desc-container').empty();
                    }
                },
                error: function (xhr, status, error) {
                    console.error('AJAX Error: ', status, error);
                }
            });
        });
    }




    getMetaDataOnVariationChange();


});